/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Rating, Typography} from "@mui/material";
import foto from '../../Recursos/tmp_producto.png'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useNavigate} from "react-router";

const Tarjeta_Producto = () => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();

    return (
        <Grid
            onClick={() => navigate('/Detalle/'+45)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderRadius: 2, backgroundColor: '#fff', cursor: 'pointer'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={foto} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{p: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 600, lineHeight: 1.1}}>Electrolit Suero</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                    <Typography sx={{fontSize: sCell ? 12 : 14, fontWeight: 400, color: '#00000080', lineHeight: 1.2}}>Electrolit
                        Suero Hidratante
                        Maracuyá Frasco X 625
                        Ml</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{fontSize: 16, fontWeight: 600}}>$ 8.700</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Rating size={'small'} defaultValue={2.5} precision={0.5}/>
                    <Typography
                        sx={{fontSize: 12, fontWeight: 400, color: '#00000050', pl: 1, mt: 0.2}}
                    >6.800</Typography>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto    